module.exports = __webpack_public_path__ + "static/media/ouch.935a2c0d.png";